import { enumToArray, _toReference } from "projects/shared-lib/src/a2-module-common/helpers/utils";
import { Roles, AdminRole as DefAdminRole, RolesAdministrative as DefRolesAdministrative } from "../core/permissions/role-def";
import { BaseModel } from "./common.model";
import { OrganizationModel } from "./organization.model";
import { ProjectModel } from "./project.model";


export interface UserModel extends BaseModel {
  displayName: string;
  name: string;
  email: string;
  emailVerified?: boolean;
  phoneNumber?: string;
  phoneNumberVerified?: boolean;
  address?: string;
  photoURL?: string;
  uid: string;
  roles: Array<UserModel.Role>;
  isDisabled?: boolean;
  organization?: OrganizationModel.Ref, // as a 'client' role, organization this user belongs to
  projects?: Array<ProjectModel.Ref>, // as an 'external' role, proects this user is allowed to see
}

export namespace UserModel {

  export interface Claims {
    roles: Array<string>;
  }
  // export const roles = () => enumToArray(UserModel.Role)
  export type Role = Roles;
  export const AdminRole = DefAdminRole;
  export const AdministrativeRoles = DefRolesAdministrative;
  // export enum Role {
  //   ADMIN = 'admin',
  //   // CLIENT = 'client',
  // }

  export const create = (userData: Partial<UserModel>): UserModel => {
    const user: UserModel = Object.assign(
      {
        id: null,
        name:'',
        displayName: '',
        email: '',
        emailVerified: false,
        uid: '',
        roles: [],
        isDisabled: false,
      }, userData
    )
    return user;
  }

  export type Ref = Pick<UserModel, 'id' | 'name' | 'displayName'>
  export const genRef = (_object: UserModel) => _toReference(['id', 'name', 'displayName'], _object);
  export type RefWithEmail = Pick<UserModel, 'id' | 'name' | 'displayName' | 'email'>
  export const genRefWithEmail = (_object: UserModel) => _toReference(['id', 'name', 'displayName', 'email'], _object);


  // export class Reference {
  //   id!: string;
  //   name!: string;
  //   displayName!: string;

  //   public static gen(user: UserModel) {
  //     const { id, displayName, name } = user;
  //     return { id, displayName, name };
  //   }
  // }
}
